import { createTheme } from "@mui/material/styles";

// Public site theme - only used for notifications & spinners; the site itself is styled in css/site.css
const theme = createTheme({
  palette: {
    primary: {
      main: "#9B7AA1",
      contrastText: "#FEF9EF",
    },
    secondary: {
      main: "#CEA2D7",
      contrastText: "#9B7AA1",
    },
    background: {
      default: "#FEF9EF",
    },
    text: {
      primary: "#9B7AA1",
    },
  },
  typography: {
    fontFamily: "\"Futura Medium BT\", \"Futura\", Arial, sans-serif",
  },
});

export default theme;
